module.exports = __webpack_public_path__ + "media/images/logos/twitter-light-b0be46df1820af6bd99ca3df33d30dd3.svg";